import { AADHAR_PROMO_PATH, getMmtWebUrl } from "../../../../constants/TrainConstants";

export const CREATE_NOW = "Create Now";
export const OKAY = "OKAY";
export const IRCTC_USERNAME = "IRCTC Username";
export const WHY_IS_IRCTC_USERNAME_REQUIRED = "Why is IRCTC username required";
export const EDUCATION_DESCRIPTION =
  "As per IRCTC, a successful train booking requires a valid IRCTC user name and password.";
export const NUDGE_DESCRIPTION =
  "IRCTC password will be required after Payment. Please ensure you enter correct username.";
export const NUDGE_DESCRIPTION_AADHAR =
  "Link your Aadhar with IRCTC ID for Tatkal Booking";
export const NUDGE_TEXT_1 =
  "After completing your payment, you’ll be redirected to IRCTC to enter your password, linked to the IRCTC ID with which you made the booking.";

export const NUDGE_TEXT_2 =
  "Your booking will be successful only after you fill in your IRCTC password, else your money will be refunded.";

export const DONT_HAVE_AN_IRCTC_ACCOUNT = 'Don’t have an IRCTC account';

// links
export const IRCTC_CREATE_ACCOUNT_URL = "https://www.irctc.co.in/nget/profile/user-registration";
// images
export const IMAGES_CDN = "https://go-assets.ibcdn.com/u/MMT/images/";
export const greenTick = "1733438045662-greenTick.png";
export const crossIcon = "1732556386196-crossIcon.webp";
export const progressBar = "1732691672667-progressBar.webp";
export const irctcCard = "1732692049217-passwordCaptcha.webp";
export const doneIcon = "1732692936761-done.webp";
export const offerIcon = "1733397416863-offers.png";

// tracking events
export const TRACK_WHY_IS_IRCTC_USERNAME_REQUIRED = "rail_travellers_irctc_edu";
export const TRACK_OKAY_CLICK = "rail_travellers_irctc_edu_ok";
// 
export const TRACK_CLOSE_BUTTON = "rail_travellers_irctc_username_cross";
export const TRACK_CHECKBOX = "rail_travellers_irctc_username_checkbox";
export const TRACK_SAVE_N_CLOSE ="rail_travellers_irctc_username_close";
export const CHECK_IRCTC_USERNAME = "rail_travellers_irctc_username_check";
export const LINK_AADHAR = "dweb_rail_travellers_link_aadhar";

export const IRCTC_AADHAR_FALLBACK = {
  aadharModal: {
    educationalText: "Link your Aadhar with IRCTC ID for Tatkal Booking",
    verificationError: "Aadhar verification is pending for this IRCTC username",
    linkUrl:
      getMmtWebUrl(AADHAR_PROMO_PATH),
    moreInfoText: "Know more",
    moreInfoUrl:
      getMmtWebUrl(AADHAR_PROMO_PATH)
  }
};

export const MODAL_ID = 'verifyUsername';